module.exports = __webpack_public_path__ + "img/020037.869e1932.png";